import { useLang } from '@/app/utils/useLang';
import EcoImg from 'eco-design/base/eco-img';
import styles from './index.module.scss';

interface ItfItem {
    text: string;
    img?: [string, string];
}
const CustomerSaying: React.FC = () => {
    const { t } = useLang('CustomerSaying');

    const items: ItfItem[] = [
        {
            text: t('text1'),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1772436667639/Frame%202094654504.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1772439406245/Frame%202094654513.jpg',
            ],
        },
        {
            text: t('text2'),
        },
        {
            text: t('text3'),
        },
        {
            text: t('text4'),
            img: [
                'https://websiteoss.ecoflow.com/upload/image/1772436655581/Frame%202094654507.jpg',
                'https://websiteoss.ecoflow.com/upload/image/1772439406245/Frame%202094654513.jpg',
            ],
        },
    ];

    return (
        <div className={`${styles.CustomerSaying} customer-saying GtmModuleData-section`} id="CustomerSaying" data-section-id="d3m-customer-saying">
            <p className="title">{t('title')}</p>
            <ul className="items">
                {items?.map((item: ItfItem, k: number) => (
                    <li className={`item ${Array.isArray(item?.img) ? 'has-img' : 'only-text'}`} key={k}>
                        {Array.isArray(item?.img) ? (
                            <EcoImg pc={item.img[0]} pad={item.img[0]} h5={item.img[1]} />
                        ) : (
                            <div className="item-quote">
                                <svg className="quote1" xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" fill="none">
                                    <path
                                        d="M16.3618 0.152739L15.9907 3.0292C15.0834 2.96735 14.3823 3.13231 13.8875 3.52408C13.3926 3.91586 13.0627 4.46229 12.8977 5.16336C12.7327 5.86443 12.7018 6.6583 12.8049 7.54495H16.3618V14.999H9.52637V6.92636C9.52637 4.49321 10.1037 2.65805 11.2584 1.42086C12.4338 0.16305 14.1349 -0.259657 16.3618 0.152739ZM6.83548 0.152739L6.46432 3.0292C5.55705 2.96735 4.85597 3.13231 4.3611 3.52408C3.86622 3.91586 3.5363 4.46229 3.37134 5.16336C3.20638 5.86443 3.17545 6.6583 3.27855 7.54495H6.83548V14.999H0V6.92636C0 4.49321 0.577355 2.65805 1.73207 1.42086C2.9074 0.16305 4.60853 -0.259657 6.83548 0.152739Z"
                                        fill="#B5B5B5"
                                    />
                                </svg>
                                <svg className="quote2" xmlns="http://www.w3.org/2000/svg" width="17" height="15" viewBox="0 0 17 15" fill="none">
                                    <path
                                        d="M0 14.8585L0.402419 11.9797C1.2898 12.0416 1.98114 11.8765 2.47642 11.4844C2.97171 11.0923 3.3019 10.5454 3.46699 9.84379C3.63209 9.14213 3.66304 8.34761 3.55986 7.46023H0V0H6.84112V8.07933C6.84112 10.5145 6.25297 12.3512 5.07667 13.5894C3.921 14.8276 2.22878 15.2506 0 14.8585ZM9.53423 14.8585L9.93665 11.9797C10.824 12.0416 11.5154 11.8765 12.0107 11.4844C12.5059 11.0923 12.8361 10.5454 13.0012 9.84379C13.1663 9.14213 13.1973 8.34761 13.0941 7.46023H9.53423V0H16.3754V8.07933C16.3754 10.5145 15.7872 12.3512 14.6109 13.5894C13.4552 14.8276 11.763 15.2506 9.53423 14.8585Z"
                                        fill="#B5B5B5"
                                    />
                                </svg>
                            </div>
                        )}
                        <p className="item-text">{item.text}</p>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CustomerSaying;
